import React from "react";

import clsx from "clsx";

import { usePrettyLogEventPage } from "@components/v2/analytics";
import { IconButton } from "@shared/buttons";

import { useChartState } from "../hooks/use-chart-state";

const MAX_CHARTS = 2;

export const AddChartButton = () => {
  const prettyLogEventPage = usePrettyLogEventPage();
  const { chartCount, addChart, removeChart } = useChartState();

  return (
    <div className="flex justify-center mb-6">
      {chartCount < MAX_CHARTS ? (
        <IconButton
          className={clsx(
            "font-bold border-l border-r border-b px-12 rounded-tr-none",
            "rounded-tl-none hover:bg-cosmic-4",
          )}
          leftIcon={<i className="fa-regular fa-sharp fa-plus text-cosmic" />}
          onClick={() => {
            prettyLogEventPage({
              domain: "Charts",
              action: "onClick",
              additionalActionInfo: "Add Chart",
            });

            addChart();
          }}
        >
          ADD CHART
        </IconButton>
      ) : (
        <IconButton
          className={clsx(
            "font-bold border-l border-r border-b px-4 rounded-tr-none",
            "rounded-tl-none text-danger hover:bg-mars-2",
          )}
          leftIcon={<i className="fa-regular fa-sharp fa-x text-danger" />}
          onClick={() => {
            prettyLogEventPage({
              domain: "Charts",
              action: "onClick",
              additionalActionInfo: "Remove Chart",
            });

            removeChart();
          }}
        >
          REMOVE SECOND CHART
        </IconButton>
      )}
    </div>
  );
};
